import { useNavigate } from 'react-router';

import { useStoryblokStrings } from '../';

/**
 * Redirects (history.push) to paths predefined in storyblok/strings/paths
 */
export const useStoryblokPath = () => {
    const paths = useStoryblokStrings('paths');
    const navigate = useNavigate();

    const redirectPathCheckScore = () => {
        return navigate(paths.check_score);
    };
    const redirectPathMyScore = () => {
        return navigate(paths.my_score);
    };

    return { redirectPathCheckScore, redirectPathMyScore };
};
